module.exports = __webpack_public_path__ + "static/image/history/m/201803@3x.jpg?b92aee2e";